document.addEventListener("turbolinks:load", function () {
  delete window?.setupBuilderFilterCheckboxEvents;

  // Check for any builder filter dropdowns. If any, continue and setup events and functions.
  if (document.querySelector(".filter-dropdown") == null) {
    return;
  }

  let dropdownSelector = ".filter-dropdown";
  let toggleSelector = ".filter-dropdown__toggle";
  let optionSelector = ".filter-dropdown-option";
  let bodySelector = ".filter-dropdown__body";
  let bodyContentsSelector = ".filter-dropdown__body-contents";
  let checkboxSelector = ".filter-checkbox";
  let counterSelector = ".filter-dropdown__counter";
  let filtersCounterSelector = "#filters-counter";

  // Sets the expanded state of the provided dropdown based on the provided expanded state.
  const setExpandedState = function($dropdown, expanded) {
    let body = $dropdown.find(bodySelector).get(0);
    let $toggle = $dropdown.find(toggleSelector);
    if (expanded) {
      let contents = $dropdown.find(bodyContentsSelector).get(0);
      $toggle.attr("aria-expanded", "true");
      body.style.height = `${contents.scrollHeight}px`;
      $(body).prop("inert", false);
    } else {
      body.style.height = `${body.scrollHeight}px`;
      requestAnimationFrame(() => {
        $toggle.attr("aria-expanded", "false");
        body.style.height = "0px";
        $(body).prop("inert", true);
      });
    }
  };

  // Checks for when a dropdown becomes inert to close.
  const dropdownInertObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "inert") {
        const $dropdown = $(mutation.target);
        if ($dropdown.is("[inert]")) {
          setExpandedState($dropdown, false);
        }
      }
    });
  });

  $(dropdownSelector).each(function(i, dropdown) {
    dropdownInertObserver.observe(dropdown, { attributes: true });
  });

  $(toggleSelector).on("click", function() {
    let expanded = $(this).attr("aria-expanded") === "true";
    let $dropdown = $(this).closest(dropdownSelector);
    // Collapse all other open dropdowns if this one is going to expand.
    if (!expanded) {
      $(toggleSelector + "[aria-expanded='true']").each(function(index, toggle) {
        let $expandedDropdown = $(toggle).closest(dropdownSelector);
        if ($dropdown !== $expandedDropdown) {
          setExpandedState($expandedDropdown, false);
        }
      });
    }
    setExpandedState($dropdown, !expanded);
  });

  $(bodySelector).on("transitionend", function() {
    if ($(this).closest(toggleSelector)?.attr("aria-expanded") === "true") {
      $(this).get(0).style.height = "auto";
    }
  });

  // Updates the dropdown counter associated with the checkbox. The counter displays how many checkboxes are selected.
  const updateCounter = function($checkbox) {
    let $dropdown = $checkbox.closest(dropdownSelector);
    updateCounterForDropdown($dropdown);
    updateTotalCounter();
  };

  const updateCounterForDropdown = function($dropdown) {
    let $counter = $dropdown.find(counterSelector);
    let $checkedBoxes = $dropdown.find(optionSelector + " " + checkboxSelector + ":checked");
    if ($checkedBoxes.length > 0) {
      $counter.text($checkedBoxes.length);
      $counter.css("display", "flex");
    } else {
      $counter.text("");
      $counter.css("display", "none");
    }
  }

  const updateTotalCounter = function() {
    let totalChecked = $("#builder-filters" + " " + optionSelector + " " + checkboxSelector + ":checked").length;
    let $filtersCounter = $(filtersCounterSelector);
    if (totalChecked > 0) {
      $filtersCounter.addClass("show");
      $filtersCounter.prop("inert", false);
    } else {
      $filtersCounter.removeClass("show");
      $filtersCounter.prop("inert", true);
    }
    $("#filters-counter-total").text(totalChecked);
  };

  const resetFilters = function() {
    let $checked = $("#builder-filters" + " " + checkboxSelector + ":checked");
    // Uncheck all checkboxes
    $checked.each(function(index, checkbox) {
      $(checkbox).prop("checked", false);
    });
    // Update all dropdown counters and collapse them
    $(dropdownSelector).each(function(index, dropdown) {
      let $dropdown = $(dropdown);
      updateCounterForDropdown($dropdown);
      setExpandedState($dropdown, false);
    });
    updateTotalCounter();
  };

  // This function exists so others can set up the filter events. This is because filter options for the builder
  // are actually populated after the page has already loaded.
  window.setupBuilderFilterCheckboxEvents = function() {
    $(checkboxSelector).on("change", function() { updateCounter($(this)); });
  };

  $("#filters-counter-reset-button").on("click", resetFilters);
});
